import { useFieldHelper, FieldProps, TextField } from 'framework/ui/field';
import { EmployeeLinkField } from 'domain/shared/employee';
import { AssignmentType } from 'domain/shared/assignment';

const AssigneeField = ({ source, ...props }: FieldProps) => {
  const { getValue: getAssignmentType } = useFieldHelper({ source });

  return getAssignmentType() === AssignmentType.INDIVIDUAL_ASSIGNMENT ? (
    <EmployeeLinkField source="employeeId" nameSource="employeeName" {...props} />
  ) : (
    <TextField source="employeeGroup.name" />
  );
};

export default AssigneeField;
